import React, { useState, useEffect } from "react";
import Header from "../../components/layout/header.jsx";
import LeftMenu from "../../components/layout/leftMenu.jsx";
import { useLocation } from "react-router-dom";
import { backendApi } from "../../api/apiService";
import { FaMoneyBillWave } from "react-icons/fa";
import { MdViewTimeline } from "react-icons/md";
import { FaLocationDot } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { BsArrowLeftCircleFill } from "react-icons/bs";
import {
  FaAddressBook,
  FaAward,
  FaClock,
  FaEnvelope,
  FaEdit,
  FaMobile,
  FaSearchLocation,
} from "react-icons/fa";
import ScheduleInterviewPopup from "../schedule/scheduleInterviewPopup.jsx";
import ShortListPopup from "./shortListPopup.jsx";

function ListTables() {
  const navigate = useNavigate();
  const [showShortList, setShowShortList] = useState(false);
  const location = useLocation();
  console.log("location", location.state);
  const [candidates, setCandidates] = useState([]);
  const [candidate, setCandidate] = useState(null);
  const [candidateId, setCandidateId] = useState("");
  const [scheduleInterview, setScheduleInterview] = useState(false);
  const [opening, setOpening] = useState({});

  useEffect(() => {
    setTimeout(() => {
      document.getElementById("ProcessingMenu").classList.add("active");
    }, 500);
  }, []);
  const handleBack = () => {
    navigate('/initialProcess');
  };
  useEffect(() => {
    if (location.state.data === "ShortListed") {
      getShortList(location.state.props.id);
    } else if (location.state.data === "Applied") {
      getAppliedList(location.state.props.id);
    } else if (location.state.data === "Hired") {
      getHiredList(location.state.props.id);
    }
    getJobOpening(location.state.props.id);
  }, []);

  const closePopup = () => {
    setScheduleInterview(false);
  };

  const Cancel = () => {
    setShowShortList(false);
  };

  const showShortListClick = (id) => {
    setCandidateId(id);
    setShowShortList(true);
  };

  const candidateInterview = (id) => {
    console.log("candId", id);
    setCandidateId(id);
    setScheduleInterview(true);
    setOpening(candidate);
  };

  const getJobOpening = (jobId) => {
    var req = {
      functionName: "getJobOpeningDetailsById",
      job_opening_id: jobId.id ? jobId.id : jobId,
      site_id: localStorage.getItem("siteId"),
    };
    backendApi(req).then((response) => {
      console.log("resp", response);
      if (response.success == 1) {
        console.log("res", response);
        setCandidate(response.JobOpeningData[0]);
      } else {
        console.log("error");
        return false;
      }
    });
  };

  function formatDateToCustomFormat(dateString) {
    const options = {
      year: "numeric",
      month: "short",
      day: "numeric",
    };

    return new Date(dateString).toLocaleDateString("en-GB", options);
  }

  function formatDate(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  const getShortList = (jobId) => {
    var req = {
      functionName: "shortListedList",
      site_id: localStorage.getItem("siteId"),
      sec_user_id: localStorage.getItem("userId"),
      job_opening_id: jobId.id ? jobId.id : jobId,
    };
    console.log("req", req);
    backendApi(req).then((response) => {
      console.log("resp", response);
      if (response.success == 1) {
        setCandidates(response.dataset);
      } else {
        console.log("error while fetching shortLists");
        return false;
      }
    });
  };

  const getAppliedList = (jobId) => {
    var req = {
      functionName: "appliedList",
      site_id: localStorage.getItem("siteId"),
      job_opening_id: jobId.id ? jobId.id : jobId,
    };
    console.log("req", req);
    backendApi(req).then((response) => {
      console.log("resp", response);
      if (response.success == 1) {
        setCandidates(response.dataset);
      } else {
        console.log("error while fetching shortLists");
        return false;
      }
    });
  };

  const getHiredList = (jobId) => {
    var req = {
      functionName: "hiredList",
      site_id: localStorage.getItem("siteId"),
      job_opening_id: jobId.id ? jobId.id : jobId,
    };
    console.log("req", req);
    backendApi(req).then((response) => {
      console.log("resp", response);
      if (response.success == 1) {
        setCandidates(response.dataset);
      } else {
        console.log("error while fetching shortLists");
        return false;
      }
    });
  };

  const goToEditPage = (candidateId) => {
    console.log("CID", candidateId);
    navigate(`/candidateprofile/${candidateId}`);
  };
  const [menuClick, setMenuClick] = useState(false)
  const toggleMenu = () => {
    setMenuClick(!menuClick)
  }
  const closeMenu = () => {
    setMenuClick(false)
  }
  return (
    <>
      <div className="main-wrapper">
        <div className="top-color"></div>
        <LeftMenu menuClick={menuClick} closeMenu={closeMenu} />
        <div className="content-wrapper">
          <Header Header="ShortListed Candidates" toggleMenu={toggleMenu} menuClick={menuClick} />
          <div className="main-container">
            <div className="card main-card">
              <div className="card-body">
                <div className="col-md-12">
                  {candidate && (
                    <div className="processDivTop">
                      <div class="mb-2">
                        <span class="label-text text-secondary"> Summary : </span>
                        <span class="font-Medium ">   {candidate.summary}</span>
                      </div>
                      <div class="mb-2">
                        <span class="label-text text-secondary"> Description : </span>
                        <span class="font-Medium ">   {candidate.description}</span>
                      </div>
                      <div class="mb-2">
                        <span class="label-text text-secondary"> Status : </span>
                        <span class="font-Medium ">   {candidate.status}</span>
                      </div>
                      <div class="mb-2">
                        <span class="label-text text-secondary"> Priority : </span>
                        <span class="font-Medium ">   {candidate.priority}</span>
                      </div>
                      <div class="mb-2">
                        <span class="label-text text-secondary"> Experience : </span>
                        <span class="font-Medium ">   {candidate.experiance} </span>
                      </div>
                      <div class="mb-2">
                        <span class="label-text text-secondary"> Location : </span>
                        <span class="font-Medium ">   {candidate.location} </span>
                      </div>
                      <div class="mb-2">
                        <span class="label-text text-secondary"> Salary : </span>
                        <span class="font-Medium ">  {candidate.salary ? candidate.salary : "NA"}</span>
                      </div>
                      <div class="mb-2">
                        <span class="label-text text-secondary"> Posted On : </span>
                        <span class="font-Medium ">  {formatDateToCustomFormat(candidate.created_on)}</span>
                      </div>
                      <div class="mb-2">
                        <span class="label-text text-secondary"> No of positions : </span>
                        <span class="font-Medium ">   {candidate.no_of_position}</span>
                      </div>
                      <div class="mb-2">
                        <span class="label-text text-secondary">Start Date  : </span>
                        <span class="font-Medium ">  {formatDate(candidate.start_date)}</span>
                      </div>
                      <div class="mb-2">
                        <span class="label-text text-secondary">Job Type  : </span>
                        <span class="font-Medium ">{candidate.job_type}</span>
                      </div>
                    </div>
                  )}
                  <div className="table-scroll table-responsive">
                    {candidates.length > 0 ? (
                      <table className="table">
                        <thead style={{ height: "30px" }}>
                          <tr>
                            <th style={{ width: '3%', minWidth: '30px' }}>#</th>
                            <th style={{ width: '28%', minWidth: '230px' }}>
                              Candidate Details
                            </th>
                            <th style={{ width: '28%', minWidth: '230px' }}>Skill Set</th>
                            <th style={{ width: '28%', minWidth: '230px' }}>Experience</th>
                            <th style={{ width: '13%', minWidth: '130px' }}>Actions</th>
                          </tr>
                        </thead>
                        {candidates?.map((candidateData, index) => {
                          return (
                            <tbody>
                              <tr>
                                <td aria-label="Lead Summary">{index + 1}</td>
                                <td aria-label="Lead Summary">
                                  <p className="schedule-td-head">
                                    {candidateData.full_name}
                                  </p>
                                  <div class="mb-2">
                                    <span class="label-text"><FaAddressBook title="address" size={12} /> </span>
                                    <span class="font-Medium ">  {candidateData.address ? candidateData.address : "NA"}</span>
                                  </div>
                                  <div class="mb-2">
                                    <span class="label-text"><FaEnvelope title="email" size={12} /> </span>
                                    <span class="font-Medium "> {candidateData.email_id ? candidateData.email_id : "NA"}</span>
                                  </div>
                                  <div class="mb-2">
                                    <span class="label-text"><FaMobile title="Contact No:" size={12} /> </span>
                                    <span class="font-Medium "> {candidateData.mobile_no
                                      ? candidateData.mobile_no
                                      : "NA"}</span>
                                  </div>
                                  <div class="mb-2">
                                    <span class="label-text"><FaSearchLocation title="location" size={12} /></span>
                                    <span class="font-Medium "> {candidateData.location ? candidateData.location : "NA"}</span>
                                  </div>
                                  <div class="mb-2">
                                    <span class="label-text"> <FaClock title="Uploaded On" size={12} /></span>
                                    <span class="font-Medium "> {formatDateToCustomFormat(
                                      candidateData.candidate_created_date
                                    )}</span>
                                  </div>

                                </td>
                                <td aria-label="Skills" style={{ textAlign: "left" }}>
                                  {candidateData.candidate_skill_set ? (
                                    candidateData.candidate_skill_set
                                      .split(",")
                                      .map((loc, i) => (
                                        <span className="skill-span me-1"
                                          key={i}
                                        >
                                          {loc.trim()}
                                        </span>
                                      ))
                                  ) : (
                                    <span style={{ fontSize: 12 }}>NA</span>
                                  )}
                                </td>
                                <td>
                                  <div class="mb-2">
                                    <span class="label-text">   <FaAward title="experience" /></span>
                                    <span class="font-Medium "> {candidateData.total_experiance}</span>
                                  </div>
                                  <div class="mb-2">
                                    <span class="label-text">  <FaMoneyBillWave title="CTC" size={12} /></span>
                                    <span class="font-Medium ">
                                      {candidateData.ctc ? candidateData.ctc : "NA"}</span>
                                  </div>
                                  <div class="mb-2">
                                    <span class="label-text">   <MdViewTimeline title="Notice Period" size={12} /></span>
                                    <span class="font-Medium ">
                                      {candidateData.notice_period
                                        ? candidateData.notice_period
                                        : "NA"}</span>
                                  </div>
                                  <div class="mb-2">
                                    <span class="label-text">  <FaLocationDot title="Preferred Location" size={12} /></span>
                                    <span class="font-Medium ">
                                      {candidateData.preferredLocation
                                        ? candidateData.preferredLocation
                                        : "NA"}</span>
                                  </div>

                                </td>
                                <td aria-label="View" style={{ textAlign: "center" }}>
                                  <div className="mt-1">
                                    <button
                                      className="btn-btn btn btn-btn2"
                                      onClick={() => goToEditPage(candidateData.candidate_id)}
                                    >
                                      Edit
                                    </button>
                                  </div>
                                  <div className="mt-1">
                                    <button
                                      className="btn-btn btn btn-btn1"
                                      onClick={() =>
                                        candidateInterview(candidateData.candidate_id)
                                      }
                                    >
                                      Schedule
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          );
                        })}
                      </table>
                    ) : (
                      <span
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <h4 className="errorMsg">No Candidates shortlisted</h4>{" "}
                      </span>
                    )}
                  </div>
                </div>
                {showShortList && (
                  <ShortListPopup
                    Cancel={Cancel}
                    candidateId={candidateId}
                    jobId={location.state.props.id}
                  />
                )}
                {scheduleInterview && (
                  <ScheduleInterviewPopup
                    onClose={closePopup}
                    candidateId={candidateId}
                    opening={opening}
                  />
                )}
              </div>
            </div>
            <button
              type="button"
              className="floating-back-button"
              onClick={handleBack}
            >
              <BsArrowLeftCircleFill size={24}/>
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default ListTables;
